



const Loading = () => {

    return (
        <div className='fl-cl loading__container'>
            <img className="loading__img" alt="logo" src={process.env.REACT_APP_LOGO} />
        </div>
    )
}

export default Loading;